import { Component } from '@angular/core';

@Component({
  selector: 'app-init-workorder-panel',
  templateUrl: './init-workorder-panel.component.html',
  styleUrls: ['./init-workorder-panel.component.scss'],
})
export class InitWorkorderPanelComponent {}
